import { orderBy, sortBy, filter } from "lodash";
import dayjs from "dayjs";
import IsBetween from "dayjs/plugin/isBetween";
import {
  ENTITY_TYPES,
  pogFilterByOptions,
  pogSortByOptions,
  itemFilterByOptions,
  itemSortByOptions,
  ssItemFilterByOptions,
  ssItemSortByOptions,
  ssPogFilterByOptions,
  ssPogSortByOptions,
  sortTypeOptions,
} from "./index";

dayjs.extend(IsBetween);

const filterHandler = (filters, data, originalData, entity) => {
  let filterByOptions = [];
  let sortByOptions = [];
  switch (entity) {
    case ENTITY_TYPES.item:
      filterByOptions = itemFilterByOptions;
      sortByOptions = itemSortByOptions;
      break;
    case ENTITY_TYPES.ssItem:
      filterByOptions = ssItemFilterByOptions;
      sortByOptions = ssItemSortByOptions;
      break;
    case ENTITY_TYPES.ssPlanogram:
      filterByOptions = ssPogFilterByOptions;
      sortByOptions = ssPogSortByOptions;
      break;
    default:
      filterByOptions = pogFilterByOptions;
      sortByOptions = pogSortByOptions;
  }

  const { filterBy, filterValue, sortBy: sortByIndex, sortType } = filters;
  let updatedData = [];

  //step 1: Filter - narrow down result.
  const filterOption = filterByOptions[filterBy];
  const filterKey = filterOption?.value;
  let filteredData = filterKey
    ? filter(data, (item) => {
        if (typeof filterKey !== "string") {
          const { field, operator, operand } = filterKey;
          const val = item[field];
          if (typeof operand === "object") {
            if (
              (operator === "exactEquals" &&
                operand?.includes(filterValue) &&
                filterValue === String(val)) ||
              (operator === "equals" && operand?.includes(val)) ||
              (operator === "greaterThan" && val > operand?.includes(val))
            ) {
              return item;
            }
          } else {
            if (
              (operator === "equals" && val === operand) ||
              (operator === "greaterThan" && val > operand)
            ) {
              return item;
            }
          }
        } else {
          const actualString = String(item[filterKey]).toLowerCase();
          const inputString = String(filterValue?.trim()).toLowerCase();
          if (filterKey === "ReleaseDate" && !!item[filterKey]) {
            const releaseDateValue = item[filterKey];
            const isValidMatch = dayjs(releaseDateValue).isBetween(
              filters.startDate,
              filters.endDate,
              "[]"
            );
            const isPartOfStartEndDate = [
              filters.startDate,
              filters.endDate,
            ].includes(dayjs(releaseDateValue).format("YYYY-MM-DD"));

            if (isValidMatch || isPartOfStartEndDate) {
              return item;
            }
            return undefined;
          }

          if (item[filterKey] && actualString.indexOf(inputString) !== -1) {
            return item;
          }
        }
      })
    : [];

  // Initial state when item list loaded.
  if (!filterBy) {
    filteredData = [...data];
  }

  //step 2: Sort - arrange the item from that result.
  if (filteredData.length > 1) {
    const sortByOption = sortByOptions[sortByIndex];
    const sortByKey = sortByOption?.value;

    if (sortByKey) {
      updatedData = sortBy(filteredData, [sortByKey]);
    } else {
      return originalData;
    }

    if (sortType) {
      const type = sortType === sortTypeOptions[0] ? "asc" : "desc";
      // Handle null values for cost fields then set it default to 0
      if (["AdjCost", "ExtendedCost"].includes(sortByKey)) {
        updatedData = orderBy(
          updatedData,
          [
            (o) => {
              return o[sortByKey] || 0; // if null then set it to 0 as default value then sort
            },
          ],
          [type]
        );
      } else {
        updatedData = orderBy(updatedData, [sortByKey], [type]);
      }
    }
  } else {
    updatedData = [...filteredData];
  }

  const alphaList = updatedData?.map((val, i) => ({
    ...val,
    __original: {
      ...val.__original,
      index: i,
    },
  }));

  return alphaList;
};

export default filterHandler;
